import axios from 'axios';

import type { UserAttributeDtoResponse } from './dto';
import { mapDtoToModel } from './mapper';
import type { UserAttribute } from './model/UserAttribute';

type SiteId = number;

const API_ROOT = `/api/v1/sites`;

function createEndpointPath(siteId: SiteId): string {
  return `${API_ROOT}/${siteId}/attributes`;
}

export async function getAllUserAttributes(siteId: SiteId): Promise<UserAttribute[]> {
  const path = createEndpointPath(siteId);
  const response = await axios.get<UserAttributeDtoResponse>(path);
  return mapDtoToModel(response.data);
}
